"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconGear = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconGear = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsx)("svg", _objectSpread(_objectSpread({
    width: "35",
    height: "35",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef,
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M33.9691 14.0956L30.0673 13.4329C29.8459 12.7342 29.5526 12.0715 29.2205 11.4088L31.502 8.20723C31.8326 7.72851 31.7967 7.06577 31.3913 6.66183L28.2631 3.53362C27.8577 3.1282 27.1964 3.05489 26.7177 3.42292L23.5162 5.70438C22.8908 5.37373 22.1907 5.07903 21.492 4.85763L20.8667 0.993372C20.756 0.403944 20.2773 0 19.6893 0H15.273C14.6836 0 14.2063 0.405416 14.0956 0.993372L13.4329 4.89517C12.7342 5.11656 12.0715 5.40981 11.4088 5.74192L8.20723 3.46046C7.72851 3.12981 7.06577 3.16575 6.66182 3.57116L3.53362 6.69936C3.1282 7.10478 3.05489 7.76605 3.42292 8.24477L5.70438 11.4463C5.37373 12.0716 5.07903 12.7718 4.85763 13.4704L0.993372 14.0958C0.403944 14.2065 0 14.6852 0 15.2732V19.6895C0 20.2789 0.405416 20.7561 0.993372 20.8668L4.89517 21.5296C5.11656 22.2282 5.40981 22.891 5.74192 23.5537L3.46046 26.7552C3.12981 27.234 3.16575 27.8967 3.57116 28.3006L6.69936 31.4288C7.10478 31.8343 7.76605 31.9076 8.24477 31.5395L11.4463 29.2581C12.0716 29.5887 12.7718 29.8834 13.4704 30.1048L14.1332 34.0066C14.2439 34.5961 14.7226 35 15.3105 35H19.7268C20.3163 35 20.7935 34.5946 20.9042 34.0066L21.5296 30.0677C22.2282 29.8463 22.891 29.553 23.5537 29.2209L26.7552 31.5024C27.234 31.833 27.8967 31.7971 28.3006 31.3917L31.4288 28.2635C31.8343 27.858 31.9076 27.1968 31.5395 26.7181L29.2581 23.5165C29.5887 22.8912 29.8834 22.1911 30.1048 21.4924L34.0066 20.8297C34.5961 20.719 35 20.2402 35 19.6523V15.2735C34.9626 14.6841 34.5572 14.2068 33.9692 14.0961L33.9691 14.0956ZM17.4812 23.775C13.985 23.775 11.1873 20.9415 11.1873 17.4811C11.1873 13.9849 14.0208 11.1871 17.4812 11.1871C20.9401 11.1871 23.7752 13.9847 23.7752 17.4811C23.7752 20.9775 20.9776 23.775 17.4812 23.775Z",
      fill: color
    }, void 0)
  }), void 0);
});